import React  from 'react';
import { IonModal, IonButton, IonLabel, IonIcon } from '@ionic/react';
import { _dict } from '../constants';
import { add, refresh } from 'ionicons/icons';
import { useUIStore } from '../stateManagement/UIZustand';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface AddOrReplaceProps {
  onClose: () => void;
  onConfirm: (mergeMode: "add" | "replace") => void;
}

const AddOrReplaceDialog: React.FC<AddOrReplaceProps> = ({ onClose, onConfirm  }) => {
  const { lang } = useGlobalStore();
  const { isAddOrReplaceDialogOpen } = useUIStore();

  let modalStyle = {
      '--max-width': '100vh',//'300px',
      '--max-height': '80vh',//'500px'
      '--border-radius': '10px',
  }

  let buttonStyle = {
    //'--background': '#007ea7',
    fontSize:"20px",
    flexGrow: 1,
    whiteSpace: 'normal',
  }



  return (
  <IonModal isOpen={isAddOrReplaceDialogOpen} style={modalStyle} onDidDismiss={() => {onClose()}}>
    <div className="ion-padding" style={{height:"100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
      <IonButton expand="block" color="light" style={buttonStyle} onClick={() => {onConfirm("add")} }>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.addCards[lang]}</IonLabel>
          <IonIcon icon={add} slot="end" size="large" />
        </div>
      </IonButton>
      <IonButton expand="block" color="light" style={buttonStyle} onClick={() => {onConfirm("replace");}}>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <IonLabel>{_dict.replaceCards[lang]}</IonLabel>
          <IonIcon icon={refresh} slot="end" size='large'/>
        </div>
      </IonButton>
      <IonButton expand="block" onClick={onClose} color="danger" style={{height:"60px", fontSize:"20px", width:"100%"}}>
          {_dict.syncBack[lang]}
      </IonButton>
  </div>

</IonModal>

  );
};

export default AddOrReplaceDialog;
